export enum TimePeriod {
	MonthlyUTC = "yyyy-MM-01",
	DailyUTC = "yyyy-MM-dd",
}
